import CustomElement from '../core/custom.js';
import Emitter from '../core/emitter.js';
import App from '../stores/app.js'

// <collapse-object class="CollapseObject">
// 	<button aria-controls="collapseID" aria-expanded="false" id="collapseID-btn" type="button" class="js-collapse-btn">button</button>
// 	<div id="collapseID" role="region" aria-labelledby="collapseID-btn" hidden="true" class="js-collapse CollapseObject__content">
// 		<div class="CollapseObject__content__inner">
// 			content
// 		</div>
// 	</div>
// </collapse-object>

export default window.customElements.define('mobile-nav', class extends CustomElement {
    constructor() {
        super();

        this.events = {
            'click .js-mobile-nav-btn': ['onToggle', {capture: true}],
            'click a' : 'onClickLink',
            'click .js-mobile-nav-panel': 'onClickPanel'
        }


        this._onClickOutside = this.onClickOutside.bind(this)
    }

    connectedCallback() {
        this.$btn = this.querySelector('.js-mobile-nav-btn')
        this.$panel = this.querySelector('.js-mobile-nav-panel')
        this.$collapseObjects = this.querySelectorAll('collapse-object')

        super.connectedCallback();

        Emitter.on('transition:leave', this.onTransitionLeave.bind(this))
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    onTransitionLeave() {
        this._close()
    }

    onClickLink() {
        this._close()
    }

    onToggle(event) {
        if (!this.matchesMedia) return
        event.preventDefault();
        event.stopPropagation();
        
        if (!this._expanded) {
            this._open()
        } else {
            this._close()
        }
    }

    onMediaquery({matches}) {
        if (!matches) {
            this._expanded = false
            this.$panel.setAttribute('hidden', true);
            document.body.classList.remove('has-mobile-menu')
        } 
    }

    onClickPanel(e) {
        e.stopPropagation()
    }

    onClickOutside() {
        this._close()
    }

    async _wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    async _open(duration = 800) {
        clearTimeout(this.timer)
        this.$panel.removeAttribute('hidden')
  
        await this._wait(0);
        
        this._expanded = true
        this.$btn.setAttribute('aria-expanded', true)
        this.classList.add('is-mobile-nav-active');
        document.body.classList.add('has-mobile-menu')

        document.body.addEventListener('click', this._onClickOutside, {once: true})
  
        this.timer = setTimeout(() => {
        
        }, duration)
    }

    async _close(duration = 800) {
        clearTimeout(this.timer);
        
        this._expanded = false
        this.$btn.setAttribute('aria-expanded', false)
        this.classList.remove('is-mobile-nav-active');
        document.body.classList.remove('has-mobile-menu')

        document.body.removeEventListener('click', this._onClickOutside, {once: true})

        this.$collapseObjects.forEach((collapseObject) => {collapseObject._close()})

        this.timer = setTimeout(() => {
            this.$panel.setAttribute('hidden', true)
        }, duration)
    }
});
